import { render, staticRenderFns } from "./FormatList.vue?vue&type=template&id=6500670c&scoped=true"
import script from "./FormatList.vue?vue&type=script&lang=js"
export * from "./FormatList.vue?vue&type=script&lang=js"
import style0 from "./FormatList.vue?vue&type=style&index=0&id=6500670c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6500670c",
  null
  
)

export default component.exports